import { RoutePath, ROUTES } from '@constants/routes';
import Error from '@pages/error/Error';
import FinancialAssistance from '@pages/financial-assistance/FinancialAssistance';
import FinancialAssistanceSuccess from '@pages/financial-assistance/success/FinancialAssistanceSuccess';
import { FvtLogin } from '@pages/fvtLogin/FvtLogin';
import { FvtWelcome } from '@pages/fvtWelcome/FvtWelcome';
import GeneticCounseling from '@pages/genetic-counseling/GeneticCounseling';
import Home from '@pages/home/Home';
import Login from '@pages/Login/login';
import { MyOrders } from '@pages/my-orders/MyOrders';
import MyTests from '@pages/MyTests/myTests';
import Results from '@pages/results/Results';
import ShareResults from '@pages/results/ShareResults';
import Settings from '@pages/settings/Settings';

export interface PageRoute {
  path: RoutePath;
  element: JSX.Element;
  auth?: boolean;
  redirect?: RoutePath;
}

const routes: PageRoute[] = [
  {
    path: '/',
    element: <Login />,
  },
  {
    path: ROUTES.LOGIN,
    element: <Login />,
  },
  {
    path: ROUTES.HOME,
    element: <Home />,
    auth: true,
  },
  {
    path: ROUTES.RESULTS,
    element: <Results />,
    auth: true,
  },
  {
    path: ROUTES.MY_ORDERS,
    element: <MyOrders />,
    auth: true,
  },
  {
    path: ROUTES.ACCOUNT,
    element: <Settings />,
    auth: true,
  },
  {
    path: ROUTES.REPORTS,
    element: <MyTests />,
    auth: true,
  },
  {
    path: ROUTES.SHARE_RESULTS,
    element: <ShareResults />,
    auth: true,
  },
  {
    path: ROUTES.ACCESS,
    element: <FinancialAssistance />,
  },
  {
    path: ROUTES.ACCESS_SUCCESS,
    element: <FinancialAssistanceSuccess />,
  },
  {
    path: ROUTES.GENETIC_COUNSELING,
    element: <GeneticCounseling />,
    auth: true,
  },
  {
    path: ROUTES.FVT_LOGIN,
    element: <FvtLogin />,
  },
  {
    path: ROUTES.FVT_WELCOME,
    element: <FvtWelcome />,
  },
  {
    path: ROUTES.ERROR,
    element: <Error />,
  },
  {
    path: '*',
    element: <Error />,
  },
];

export default routes;
